module.exports = __webpack_public_path__ + "img/PTFvsAlamo.11b1965e.png";